import AuthService                    from 'services/auth.service';
import React, { useState, useEffect } from 'react';
import UserService                    from 'services/user.service';
import ProfilePlaceholder             from 'assets/icons/profile-placeholder.png';

const Profile = () => {
  const currentUser                   = AuthService.getCurrentUser();
  const [profile, setProfile]         = useState('');
  const [avatar, setAvatar]           = useState(ProfilePlaceholder);
  const [generalInfo, setGeneralInfo] = useState(<span></span>);
  const [credentials, setCredentials] = useState(<span></span>);
  const [additional, setAdditional]   = useState(<span></span>);
  const [emailList, setEmailList]     = useState(<span></span>);
  const assistantViewDoctorLink       = window.location.search.match(/view_doctor_id=(\d+)/);
  const specificDoctorId              = assistantViewDoctorLink ? assistantViewDoctorLink[1] : null;
  const searchDocId                   = specificDoctorId || currentUser.id

  useEffect(() => {
    UserService.profile(searchDocId).then(
      (data) => {
        setProfile(data);
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (profile) {
      if (profile.avatar?.styles?.origin?.url) {
        setAvatar(profile.avatar?.styles?.origin?.url);
      }

      const title_width = "w-em-36 mb-0";

      // General Info
        const general_info = [
          { title: 'Email',         value: profile.email },
          { title: 'Phone Number',  value: '+' + profile.phone_number }
        ];

        profile.specialties.forEach((hash, index) => {
          general_info.push({ title: 'Specialty ' + (index + 1), value: hash.name });
        });

        if (profile.specialties.length === 0) {
          general_info.push({ title: 'Specialty', value: '-' });
        }

        const displayedInfo = general_info.map((hash, index) => {
          return(
            <div className="d-lg-flex pt-2 pb-1" key={ index }>
              <h6 className={ title_width }>{ hash?.title }</h6>
              <p className="mt-lg-0 mt-2 mb-lg-0 mb-4">{ hash?.value }</p>
            </div>
          )
        });

        setGeneralInfo(displayedInfo);

      // Credentials
        var credentials_array = profile.qualifications.map((hash, index) => {
          return { title: index === 0 ? 'Qualifications' : '', value: hash.name };
        });

        if (profile.qualifications.length === 0) {
          credentials_array.push({ title: 'Qualifications', value: '-' });
        }

        credentials_array.push({ title: 'Medical Registration No.',          value: profile.mmc });
        credentials_array.push({ title: 'National Specialist Registry No.',  value: profile.nsr });

        const displayedQualifications = credentials_array.map((hash, index) => {
          return(
            <div className="d-lg-flex pt-2 pb-1" key={ index }>
              <h6 className={ title_width }>{ hash?.title }</h6>
              <p className="mt-lg-0 mt-2 mb-lg-0 mb-4">{ hash?.value }</p>
            </div>
          )
        });

        setCredentials(displayedQualifications);

      // Additional Info
        var additional_array = [];

        profile.educations.forEach((hash, index) => {
          additional_array.push({ title: index === 0 ? 'Education' : '', value: hash.name });
        });

        if (profile.educations.length === 0) {
          additional_array.push({ title: 'Education', value: '-' });
        }

        profile.hospitals.forEach((hash, index) => {
          additional_array.push({ title: index === 0 ? 'Hospital Affiliation' : '', value: hash.name });
        });

        if (profile.hospitals.length === 0) {
          additional_array.push({ title: 'Hospital Affiliation', value: '-' });
        }

        profile.special_interests.forEach((hash, index) => {
          additional_array.push({ title: index === 0 ? 'Special Interests' : '', value: hash.name });
        });

        if (profile.special_interests.length === 0) {
          additional_array.push({ title: 'Special Interests', value: '-' });
        }

        if (profile.languages && profile.languages.length !== 0) {
          additional_array.push({ title: 'Languages', value: profile.languages.split('|').join(', ') });
        }

        const displayedAdditional = additional_array.map((hash, index) => {
          return(
            <div className="d-lg-flex pt-2 pb-1" key={ index }>
              <h6 className={ title_width }>{ hash?.title }</h6>
              <p className="mt-lg-0 mt-2 mb-lg-0 mb-4">{ hash?.value }</p>
            </div>
          )
        });

        setAdditional(displayedAdditional);

      // Email Recipients
        var email_array = [];

        profile.recipients_emails.forEach((hash, index) => {
          email_array.push({ title: 'Email Recipient ' + (index + 1), value: hash.email });
        });

        if (profile.recipients_emails.length === 0) {
          email_array.push({ title: 'Email Recipients', value: '-' });
        }

        const displayedEmailRecipients = email_array.map((hash, index) => {
          return(
            <div className="d-lg-flex pt-2 pb-1" key={ index }>
              <h6 className={ title_width }>{ hash?.title }</h6>
              <p className="mt-lg-0 mt-2 mb-lg-0 mb-4">{ hash?.value }</p>
            </div>
          )
        });

        setEmailList(displayedEmailRecipients);
    }
  }, [profile]);

  return (
    <div id="main-content-target">
      <h1 className="text-danger mb-4">Profile</h1>

      <div id="profile-main-container" className="d-lg-flex">
        <div className="text-center w-lg-em-36 mt-6 px-6">
          <img src={ avatar } alt="avatar-profile" className="rounded-circle w-em-20 my-6" />
          <h5>{ profile?.title ? profile?.title + ' ' + profile?.name : profile?.name }</h5>
          <p>{ profile?.timezone?.utc_timezone_text + ' - ' + profile?.timezone?.name }</p>
        </div>

        <div className="flex-grow-1">
          <div className="border-left border-bottom py-8 px-8">
            <h5>General Information</h5>
            { generalInfo }
          </div>

          <div className="border-left border-bottom py-8 px-8">
            <h5>Credentials</h5>
            { credentials }
          </div>

          <div className="border-left border-bottom py-8 px-8">
            <h5>Additional Info</h5>
            { additional }
          </div>

          <div className="border-left py-8 px-8">
            <h5>Email Recipients for Appointment Notifications</h5>
            <p>(Max. 3 Emails)</p>
            { emailList }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;